export const menuItems = [{
    id: 1,
    perm: "view_dashboard",
    label: "Home",
    icon: "bx-home-circle",
    link: "/"
},
{
    id: 7,
    perm: "new_sale",
    actionpage: "1",
    label: "Record Sale",
    icon: "bx-cart",
    link: "/record_order"
},
{
    id: 57,
    perm: "view_business_documents",
    label: "Business Documents",
    icon: "bx-store",
    subItems: [{
        id: 157,
        perm: "view_invoices",
        label: "Invoices",
        link: "/invoices",
        parentId: 57
    },
    {
        id: 158,
        perm: "view_quotations",
        label: "Quotations",
        link: "/quotations/view",
        parentId: 57
    },
    {
        id: 159,
        perm: "view_lpo",
        label: "Purchase Orders",
        link: "/lpo",
        parentId: 57
    },
    ]
},
{
    id: 89,
    perm: "production_batch_input",
    actionpage: "1",
    icon: "bx-store",
    label: "Batch Input",
    link: "/production/cart",
},
{
    id: 90,
    perm: "view_production_batches",
    label: "Production Batches",
    icon: "bx-store",
    link: "/production/batches",
},
{
    id: 91,
    perm: "view_cash_in",
    label: "Other Incomes",
    icon: "bx-money",
    link: "/otherincomes",
},
{
    id: 36,
    perm: "consumables_tab",
    label: "Production Section",
    icon: "bx-grid",
    subItems: [{
        id: 9,
        actionpage: "1",
        perm: "add_consumable_items",
        label: "Input Items",
        subItems: [{
            id: 37,
            perm: "add_consumable_items",
            actionpage: "1",
            label: "View Items",
            link: "/consumables/add_item",
            parentId: 9
        },
        {
            id: 11,
            perm: "add_consumable_items",
            actionpage: "1",
            label: "Item Units",
            link: "/consumables/item_units",
            parentId: 9
        },
        ],
        parentId: 36
    },
    {
        id: 8,
        perm: "stocking_consumables",
        label: "Stock",
        subItems: [{
            id: 6,
            perm: "stocking_report",
            label: "Current Stock",
            link: "/consumables/currentstock",
            parentId: 8
        },
        {
            id: 38,
            perm: "stocking_consumables",
            actionpage: "1",
            label: "Add to Stock",
            link: "/consumables/stocking",
            parentId: 8
        },
        {
            id: 58,
            perm: "reconcile_consumables_stock",
            actionpage: "1",
            label: "menuitems.stock.list.reconcile",
            link: "/consumables/reconcile",
            parentId: 8
        },
        {
            id: 59,
            perm: "view_spoilt_consumables",
            label: "menuitems.stock.list.spoilt",
            link: "/consumables/spoilt",
            parentId: 8
        },
        ],
        parentId: 36
    },
    {
        id: 80,
        set: "use_bill_of_materials",
        perm: "set_ingredients",
        label: "Bill of Materials",
        subItems: [{
            id: 60,
            perm: "add_consumable_items",
            label: "View Bill of Materials",
            link: "/view_bill_of_materials",
            parentId: 80
        },
        {
            id: 61,
            perm: "add_consumable_items",
            actionpage: "1",
            label: "Set Bill of Materials",
            link: "/set_bill_of_materials",
            parentId: 80
        },
        ],
        parentId: 36
    },
    {
        id: 145,
        set: "use_bill_of_materials",
        perm: "using_consumables",
        actionpage: "1",
        label: "Use Raw Materials",
        link: "/use_raw_materials",
        parentId: 36,
    },
    {
        id: 147,
        set: "use_bill_of_materials",
        perm: "record_output",
        actionpage: "1",
        label: "Output",
        link: "/output",
        parentId: 36,
    },
    {
        id: 146,
        set: "use_bill_of_materials",
        perm: "using_consumables",
        actionpage: "1",
        label: "Report Finished",
        link: "/report_finished",
        parentId: 36,
    },
    {
        id: 149,
        set: "multiple_factories",
        perm: "view_factory_stock",
        label: "Production Factories",
        parentId: 36,
        link: "/production/factories",
    },
    {
        id: 152,
        set: "produce_multiple_products",
        label: "Output Products",
        parentId: 36,
        link: "/output_products",
    },
    {
        id: 41,
        perm: "stocking_report",
        label: "Input Purchases Report",
        parentId: 36,
        link: "/consumables/stocking_report",
    },
    {
        id: 42,
        perm: "usage_report",
        label: "Input Usage Report",
        parentId: 36,
        link: "/consumables/usage_report",
    },
    {
        id: 43,
        perm: "stocking_consumables",
        label: "Creditors report",
        parentId: 36,
        link: "/consumables/creditors",
    },
    ]
},
{
    id: 420,
    perm: "view_factory_stock",
    label: "Factories Stock",
    icon: "bx-store",
    subItems: [{
        id: 162,
        perm: "view_factory_stock",
        label: "Factories Production Batches",
        link: "/factory_stock/production_batches",
        parentId: 420
    },
    {
        id: 163,
        perm: "view_factory_stock",
        label: "Stock",
        link: "/factory_stock/stock",
        parentId: 420
    },
    {
        id: 164,
        perm: "view_factory_stock",
        label: "Factories stock value",
        link: "/factory_stock/stockvalue",
        parentId: 420
    },
    {
        id: 167,
        perm: "reconcile_factory_stock",
        actionpage: "1",
        label: "Reconcile factory stock",
        link: "/factory_stock_taking",
        parentId: 420
    },
    {
        id: 168,
        perm: "save_factory_stock_reconciliation",
        label: "menuitems.stock.list.report",
        link: "/factory_stock/reconcilation_report",
        parentId: 420
    },
    ]
},
{
    id: 35,
    perm: "view_services",
    label: "Services",
    icon: "bx-briefcase",
    link: "/services",
},
{
    id: 12,
    perm: "stock_tab",
    label: "Inventory",
    icon: "bx-store",
    subItems: [{
        id: 14,
        perm: "add_shop_stock",
        actionpage: "1",
        label: "Add Inventory",
        link: "/purchase/new",
        parentId: 12
    },
    {
        id: 13,
        perm: "view_shop_stock",
        label: "Inventory Level",
        link: "/stock/view",
        parentId: 12
    },
    {
        id: 15,
        perm: "view_spoilt_stock",
        label: "Spoilt Inventory",
        link: "/stock/spoilt",
        parentId: 12
    },
    {
        id: 17,
        perm: "reconcile_shop_stock",
        actionpage: "1",
        label: "Reconcile Inventory",
        link: "/stock_taking",
        parentId: 12
    },
    {
        id: 19,
        perm: "view_reconciliation_report",
        label: "menuitems.stock.list.report",
        link: "/reconciliation/report",
        parentId: 12
    },
    ]
},
{
    id: 120,
    set: "enable_consumables",
    perm: "stocking_consumables",
    label: "Finished Goods",
    icon: "bx-store",
    subItems: [{
        id: 121,
        perm: "add_products",
        actionpage: "1",
        label: "Add Items",
        link: "/add_item",
        parentId: 120
    },
    {
        id: 122,
        perm: "view_products",
        label: "View Items",
        link: "/view_items",
        parentId: 120
    },
    {
        id: 123,
        perm: "view_shop_stock",
        label: "Inventory Level",
        link: "/view_inventory_levels",
        parentId: 120
    },
    {
        id: 124,
        perm: "view_spoilt_stock",
        label: "Spoilt Inventory",
        link: "/spoilt_inventory",
        parentId: 120
    },
    {
        id: 125,
        perm: "reconcile_shop_stock",
        actionpage: "1",
        label: "Stock Taking",
        link: "/stock_taking",
        parentId: 120
    },
    {
        id: 126,
        perm: "view_reconciliation_report",
        label: "Stock Taking Report",
        link: "/stock_taking_report",
        parentId: 120
    },
    ]
},
{
    id: 29,
    perm: "products_tab",
    label: "Items",
    icon: "bx-grid",
    subItems: [{
        id: 28,
        perm: "add_products",
        actionpage: "1",
        label: "Add Items",
        link: "/add_item",
        parentId: 29
    },
    {
        id: 27,
        perm: "view_products",
        label: "Search Items",
        link: "/products/search_products",
        parentId: 29
    },
    {
        id: 30,
        perm: "view_products",
        label: "View Items",
        link: "/products/view",
        parentId: 29
    },
    {
        id: 31,
        perm: "view_product_categories",
        label: "Items Categories",
        link: "/categories/view",
        parentId: 29
    },
    {
        id: 33,
        perm: "view_units",
        label: "Units",
        parentId: 29,
        link: "/units/view",
    },
    {
        id: 34,
        perm: "view_product_units",
        set: "allow_multiple_units",
        label: "Items Units",
        parentId: 29,
        link: "/products/units",
    }
    ]
},
{
    id: 37,
    perm: "expenses_tab",
    label: "menuitems.expenses.text",
    icon: "bx-food-menu",
    subItems: [{
        id: 3712,
        perm: "view_expenses",
        actionpage: "1",
        label: "Record Expense",
        link: "/expenses/record",
        parentId: 37
    },
    {
        id: 372,
        perm: "view_expenses",
        actionpage: "1",
        label: "Creditors ",
        link: "/expenses/creditors",
        parentId: 37
    },
    {
        id: 38,
        perm: "view_expenses",
        actionpage: "1",
        label: "Expenses",
        link: "/expenses/view",
        parentId: 37
    },
    {
        id: 39,
        perm: "view_expense_categories",
        actionpage: "1",
        label: "menuitems.expenses.list.categories",
        link: "/expenses/categories",
        parentId: 37
    },
    {
        id: 40,
        perm: "view_expenses_report",
        label: "menuitems.expenses.list.report",
        link: "/expenses_report",
        parentId: 37
    },
    ]
},
{
    id: 52,
    perm: "advanced_features_tab",
    label: "Customers & Suppliers",
    icon: "bxs-folder-open",
    subItems: [{
        id: 271,
        perm: "view_suppliers",
        label: "Suppliers",
        link: "/suppliers/view",
        parentId: 52
    },
    {
        id: 272,
        perm: "view_supplier_deposits",
        label: "Supplier Deposits",
        link: "/supplier/deposits",
        parentId: 52
    },
    {
        id: 273,
        perm: "view_supplierbalances",
        label: "Supplier Balances",
        link: "/supplier_balances",
        parentId: 52
    },
    {
        id: 274,
        perm: "view_customers",
        label: "Customers",
        link: "/customers",
        parentId: 52
    },
    {
        id: 300,
        perm: "view_customers",
        set: "customer_location",
        label: "Customer Locations",
        link: "customer_locations",
        parentId: 52
    },
    {
        id: 275,
        perm: "view_customer_deposits",
        label: "Customer Deposits",
        link: "/customer/deposits",
        parentId: 52
    },
    {
        id: 276,
        perm: "view_customer_balances",
        label: "Customer Balances",
        link: "/customer/balances",
        parentId: 52
    },
    ]
},
{
    id: 46,
    perm: "reports_tab",
    label: "Action Reports",
    icon: "bxs-folder-open",
    subItems: [{
        id: 47,
        perm: "view_sales_report",
        label: "menuitems.reports.list.sreport",
        link: "/sales",
        parentId: 46
    },
    {
        id: 247,
        perm: "view_payments_report",
        label: "Payments Report",
        link: "/payments",
        parentId: 46
    },
    {
        id: 248,
        perm: "view_purchase_payments_report",
        label: "Purchase Payments",
        link: "/purchase_payments",
        parentId: 46
    },
    {
        id: 48,
        perm: "view_purchases_report",
        label: "menuitems.reports.list.preport",
        link: "/shop/purchases",
        parentId: 46
    },
    {
        id: 49,
        perm: "view_debtors_report",
        label: "menuitems.reports.list.debtor",
        link: "/sales/debtors",
        parentId: 46
    },
    {
        id: 50,
        perm: "view_creditors_report",
        label: "Creditors Report",
        link: "/purchases/creditors",
        parentId: 46
    },
    {
        id: 61,
        perm: "view_sales_report",
        set: "track_untake_orders",
        label: "Untaken Orders",
        link: "/reports/untaken_orders",
        parentId: 46
    },
    ]
},
{
    id: 53,
    perm: "reports_tab",
    label: "Analysis Reports",
    icon: "bxs-folder-open",
    subItems: [{
        id: 150,
        perm: "view_factory_performance_report",
        label: "Factory Performance Report",
        parentId: 36,
        link: "/factory_performance",
    },
    {
        id: 476,
        perm: "view_transactions_report",
        label: "Transactions Report",
        link: "/advanced_reports/transactions_report",
        parentId: 53
    },
    {
        id: 477,
        perm: "view_advanced_sales_report",
        label: "Product Sales Report",
        link: "/advanced_reports/sales_report",
        parentId: 53
    },
    {
        id: 478,
        perm: "view_payments_report",
        label: "Credit Payments",
        link: "/advanced_reports/credit_payments",
        parentId: 53
    },
    {
        id: 479,
        perm: "view_payments_report",
        label: "User Logs",
        link: "/user_logs",
        parentId: 53
    },
    ]
},
{
    id: 93,
    set: "enable_coa",
    perm: "view_financial_statements",
    label: "Accounting",
    icon: "bxs-folder-open",
    subItems: [{
        id: 150,
        perm: "view_chartsofaccounts",
        label: "COA Accounts",
        parentId: 93,
        link: "/coa_accounts",
    },
    {
        id: 476,
        perm: "view_trialbalance",
        label: "Trial Balance",
        link: "/trial_balance",
        parentId: 93
    },
    {
        id: 477,
        perm: "view_incomestatement",
        label: "Income Statement",
        link: "/income_statement",
        parentId: 93
    },
    {
        id: 478,
        perm: "view_balancesheet",
        label: "Balance Sheet",
        link: "/balance_sheet",
        parentId: 93
    },
    ]
},
{
    id: 51,
    perm: "advanced_features_tab",
    set: "manage_vehicles",
    label: "Vehicles",
    icon: "bxs-folder-open",
    subItems: [{
        id: 449,
        perm: "add_vehicle_deliveries",
        actionpage: "1",
        label: "Add Deliveries",
        link: "/vehicle/deliveries",
        parentId: 51
    },
    {
        id: 450,
        perm: "view_vehicle_deliveries",
        label: "Vehicle Deliveries Report",
        link: "/vehicle/deliveries/report",
        parentId: 51
    },
    {
        id: 452,
        perm: "add_vehicle_expenses",
        actionpage: "1",
        label: "Vehicle Expenses",
        link: "/vehicle/expenses",
        parentId: 51
    },
    {
        id: 453,
        perm: "view_vehicle_expenses",
        label: "Vehicle Expenses Report",
        link: "/vehicle/expenses/report",
        parentId: 51
    },
    {
        id: 451,
        perm: "add_vehicles",
        actionpage: "1",
        label: "Vehicles",
        link: "/vehicles",
        parentId: 51
    },
    ]
},
{
    id: 81,
    set: "manage_staff",
    perm: "advanced_features_tab",
    label: "Staff",
    icon: "bx-group",
    subItems: [{
        id: 180,
        perm: "view_staff",
        label: "View Staff",
        link: "/staff",
        parentId: 81
    },
    {
        id: 181,
        perm: "view_staff",
        label: "Staff Positions",
        link: "/staff_positions",
        parentId: 81
    },
    {
        id: 182,
        perm: "view_staff_payroll",
        label: "Staff Payroll",
        link: "/staff_payroll",
        parentId: 81
    },
    {
        id: 183,
        perm: "view_staff_salaries",
        label: "Staff Salaries",
        link: "/staff_salaries",
        parentId: 81
    },
    {
        id: 184,
        perm: "view_staff_advances",
        label: "Staff Advances",
        link: "/staff_advances",
        parentId: 81
    },
    {
        id: 185,
        perm: "view_staff_salaries",
        label: "Staff Allowances",
        link: "/staff_allowances",
        parentId: 81
    },
    {
        id: 186,
        perm: "view_staff_salaries",
        label: "Monthly Staff Salaries",
        link: "/monthly_staff_salaries",
        parentId: 81
    },
    
    ]
},
{
    id: 54,
    perm: "advanced_features_tab",
    label: "Settings",
    icon: "bxs-folder-open",
    subItems: [{
        id: 471,
        perm: "view_payment_options",
        label: "Payment Options",
        link: "/payment/options",
        parentId: 54
    },
    {
        id: 472,
        perm: "view_money_transfers",
        label: "Money Transfers",
        link: "/payment/transfers",
        parentId: 54
    },
    {
        id: 473,
        perm: "manage_permissions",
        label: "Permissions",
        link: "/users/permissions",
        parentId: 54
    },
    {
        id: 474,
        perm: "view_user_roles",
        label: "User Roles",
        link: "/users/groups",
        parentId: 54
    },
    {
        id: 475,
        perm: "view_users",
        label: "Users",
        link: "/users",
        parentId: 54
    },
    ]
},
{
    id: 129,
    perm: "view_products",
    set: "enable_marketplace",
    label: "Market Place",
    icon: "bx-shopping-bag",
    subItems: [{
        id: 130,
        perm: "add_products",
        actionpage: "1",
        label: "Add Items",
        link: "/marketplace/add_item",
        parentId: 129
    },
    {
        id: 131,
        perm: "view_products",
        label: "View Items",
        link: "/marketplace/view_items",
        parentId: 129
    },
    {
        id: 132,
        perm: "view_product_categories",
        label: "Items Categories",
        link: "/marketplace/categories",
        parentId: 129
    }
    ]
},
{
    id: 151,
    perm: "view_messages",
    actionpage: "1",
    label: "Custom SMS",
    icon: "bx-message-square-dots",
    link: "/custom_sms"
},
];